module.exports = __webpack_public_path__ + "static/media/small-screen01.cd541eb8.png";